import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.reduce.js";
import "core-js/modules/esnext.iterator.some.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import store from '../../store';
import isEqual from 'lodash-es/isEqual';
import moment from "moment";
import Translations from "./translations/all-translations";
import findIndex from "lodash-es/findIndex";
import cloneDeep from "lodash-es/cloneDeep";
import mergeWith from "lodash-es/mergeWith";
import BulletBlock from "./models/blocks/BulletBlock";
import ButtonBlock from "./models/blocks/ButtonBlock";
import FaqBlock from "./models/blocks/FaqBlock";
import FaqsBlock from "./models/blocks/FaqsBlock";
import FigureBlock from "./models/blocks/FigureBlock";
import FiguresBlock from "./models/blocks/FiguresBlock";
import GalleryBlock from "./models/blocks/GalleryBlock";
import HeaderBlock from "./models/blocks/HeaderBlock";
import JournalBlock from "./models/blocks/JournalBlock";
import ReviewBlock from "./models/blocks/ReviewBlock";
import ReviewsBlock from "./models/blocks/ReviewsBlock";
import SimpleGalleryBlock from "./models/blocks/SimpleGalleryBlock";
import SingleImageBlock from "./models/blocks/SingleImageBlock";
import VideoBlock from "./models/blocks/VideoBlock";
import TrustBlock from "./models/blocks/TrustBlock";
import TrustBadgeBlock from "./models/blocks/TrustBadgeBlock";
import HeroBlock from "./models/blocks/HeroBlock";
import BulletBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/BulletBlockForm";
import ButtonBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/ButtonBlockForm";
import FaqBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/FaqBlockForm";
import FaqsBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/FaqsBlockForm";
import FigureBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/FigureBlockForm";
import FiguresBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/FiguresBlockForm";
import GalleryBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/GalleryBlockForm";
import HeaderBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/HeaderBlockForm";
import JournalBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/JournalBlockForm";
import ReviewBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/ReviewBlockForm";
import ReviewsBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/ReviewsBlockForm";
import SimpleGalleryBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/SimpleGalleryBlockForm";
import SingleImageBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/SingleImageBlockForm";
import VideoBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/VideoBlockForm";
import TrustBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/TrustBlockForm";
import TrustBadgeBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/TrustBadgeBlockForm";
import HeroBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/HeroBlockForm";
import ProductListBlock from "./models/blocks/ProductListBlock";
import ProductListBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/ProductListBlockForm";
import MainSectionSVG from "../../components/svg-components/MainSectionSVG";
import PurchaseGiftSVG from "../../components/svg-components/PurchaseGiftSVG";
import CallAgentSVG from "../../components/svg-components/CallAgentSVG";
import AboutUsSVG from "../../components/svg-components/AboutUsSVG";
import TrustedSiteIcon from "../../components/svg-components/TrustedSiteIcon";
import TruckIcon from "../../components/svg-components/TruckIcon";
import SecureCheckoutIcon from "../../components/svg-components/SecureCheckoutIcon";
import CallAgentIcon from "../../components/svg-components/CallAgentIcon";
import ReturnGuarantee from "../../components/svg-components/ReturnGuarantee";
import Model from "../../views/dashboard/models/Model";
import BrandDomainBlock from "./models/blocks/BrandDomainBlock";
import BrandDomainBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/BrandDomainBlockForm";
import BasicAuth from "../../views/dashboard/models/ecommerceSdk/BasicAuth";
import BasicAuthForm from "../../views/dashboard/warehouse/BasicAuthForm";
import BearerTokenAuth from "../../views/dashboard/models/ecommerceSdk/BearerTokenAuth";
import BearerTokenAuthForm from "../../views/dashboard/warehouse/BearerTokenAuthForm";
import JsonMapper from "./models/helpers/JsonMapper";
import JsonArrayMapper from "./models/helpers/JsonArrayMapper";
import JsonMappedModel from "./models/helpers/JsonMappedModel";
import User from "../../views/dashboard/models/User";
import ArticleBlock from "./models/blocks/ArticleBlock";
import ArticleBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/ArticleBlockForm";
import ContactBlock from "./models/blocks/ContactBlock";
import ContactBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/ContactBlockForm";
import PageHeaderBlock from "./models/blocks/PageHeaderBlock";
import PageHeaderBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/PageHeaderBlockForm";
import LinkBlock from "./models/blocks/LinkBlock";
import LinkBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/LinkBlockForm";
import PageFooterBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/PageFooterBlockForm";
import FooterInfoBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/FooterInfoBlockForm";
import FooterLinksBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/FooterLinksBlockForm";
import FooterBenefitsBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/FooterBenefitsBlockForm";
import ContentPlaceholderBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/ContentPlaceholderBlockForm";
import ContentPlaceholderBlock from "./models/blocks/ContentPlaceholderBlock";
import PageFooterBlock from "./models/blocks/PageFooterBlock";
import FooterInfoBlock from "./models/blocks/FooterInfoBlock";
import FooterLinksBlock from "./models/blocks/FooterLinksBlock";
import FooterBenefitsBlock from "./models/blocks/FooterBenefitsBlock";
import ComplianceBarBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/ComplianceBarBlockForm";
import ComplianceBarBlock from "./models/blocks/ComplianceBarBlock";
import SocialMediaLinkBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/SocialMediaLinkBlockForm";
import SocialMediaLinkBlock from "./models/blocks/SocialMediaLinkBlock";
import AnnouncementBarBlock from "./models/blocks/AnnouncementBarBlock";
import AnnouncementBarBlockForm from "../../views/dashboard/sale-page/page-blocks/forms/AnnouncementBarBlockForm";
function getTranslation(text = '', to_lang = 'en', params = {}) {
  var _text$split, _text$split2, _Translations$to_lang, _Object$keys$reduce;
  let text_split = (_text$split = text === null || text === void 0 || (_text$split2 = text.split) === null || _text$split2 === void 0 ? void 0 : _text$split2.call(text, '.')) !== null && _text$split !== void 0 ? _text$split : [];
  if (!Array.isArray(text_split)) return text;
  let translation = text_split.length > 0 ? text_split.reduce((pt, k) => pt === null || pt === void 0 ? void 0 : pt[k], Translations === null || Translations === void 0 ? void 0 : Translations[to_lang]) : Translations === null || Translations === void 0 || (_Translations$to_lang = Translations[to_lang]) === null || _Translations$to_lang === void 0 ? void 0 : _Translations$to_lang[text];
  if (!translation) return text;
  if (!isString(translation)) return translation;
  return (_Object$keys$reduce = Object.keys(params).reduce((pt, k) => {
    var _params$k;
    return pt.replace(`{${k}}`, ((_params$k = params[k]) === null || _params$k === void 0 || (_params$k = _params$k.toString()) === null || _params$k === void 0 ? void 0 : _params$k.length) > 0 ? params[k] : null);
  }, translation)) !== null && _Object$keys$reduce !== void 0 ? _Object$keys$reduce : text;
}
const getType = v => Object.prototype.toString.call(v).slice(8, -1);
const isObject = v => getType(v) === 'Object';
const isString = v => getType(v) === 'String';
const isArray = v => getType(v) === 'Array';
const isFunction = v => ['AsyncFunction', 'Function'].includes(getType(v));
const isBoolean = v => getType(v) === 'Boolean';
const hasAstrix = v => isArray(v) && v.some(item => item === '*');
function isJSON(str) {
  try {
    JSON.parse(str);
    return true;
  } catch (error) {
    return false;
  }
}
function MOA(o, c = null, a = 'messages', sa = 'content', fn = 'fieldName', ci = [], ck = null) {
  var _ck;
  if (!isObject(o) || !c) return;
  ck = (_ck = ck) !== null && _ck !== void 0 ? _ck : o[fn];
  let messages = c === null || c === void 0 ? void 0 : c[ck];
  if (messages) o[a] = messages;
  return Object.keys(o).forEach(k => {
    let messages = c === null || c === void 0 ? void 0 : c[[ck, k].filter(e => e).join('.')];
    if (messages) o[a] = messages;
    if (isObject(o[k])) {
      var _o$fn;
      MOA(o[k], c, a, sa, fn, ci, [ck, (_o$fn = o[fn]) !== null && _o$fn !== void 0 ? _o$fn : k].filter(e => e).join('.'));
    } else if (isArray(o[k])) {
      if (k === sa) ck = [ck, k].join('.');
      o[k].forEach((sk, i) => {
        var _ref;
        if (!sk) return;
        let arr_msg = c === null || c === void 0 ? void 0 : c[(_ref = [ck, i.toString(), sa]) === null || _ref === void 0 || (_ref = _ref.filter(e => e)) === null || _ref === void 0 ? void 0 : _ref.join('.')];
        if (arr_msg) sk[a] = arr_msg;
        MOA(sk, c, a, sa, fn, ci, [ck, i.toString(), sk[fn]].filter(e => e).join('.'));
      });
    }
  });
}
function EmptyFormValidations(form) {
  if (getType(form) !== 'Object') return;
  if (Array.isArray(form)) form.forEach(subForm => EmptyFormValidations(subForm));
  Object.keys(form).forEach(form_field => {
    var _form$form_field;
    return (_form$form_field = form[form_field]) !== null && _form$form_field !== void 0 && _form$form_field.hasOwnProperty('messages') ? form[form_field].messages = [] : null;
  });
}
function EmptyFormFields(form) {
  if (!isObject(form)) return;
  Object.keys(form).forEach(form_field => {
    if (!form[form_field].hasOwnProperty('content')) return;
    isFunction(form[form_field].default) ? form[form_field].default() : form[form_field].content = form[form_field].default !== undefined ? form[form_field].default : null;
  });
}
function PopulateFormFields(form, data, exceptions = [], objectHandler = null) {
  if (!form || typeof form !== 'object' || !data || typeof data !== 'object') return;
  EmptyFormFields(form);
  Object.keys(form).forEach(field_key => {
    var _form$field_key, _form$field_key2;
    if (Array.isArray(exceptions) && exceptions.includes(field_key) || (_form$field_key = form[field_key]) !== null && _form$field_key !== void 0 && _form$field_key.dontPopulate) return;
    let modelKey = (_form$field_key2 = form[field_key]) === null || _form$field_key2 === void 0 ? void 0 : _form$field_key2.modelKey;
    let modelKeySplit = isString(modelKey) ? modelKey.split('.') : [];
    let modelKeyReduce = modelKeySplit.reduce((a, b) => a === null || a === void 0 ? void 0 : a[b], data);
    let use_handler = isFunction(form[field_key].populationHandler) ? form[field_key].populationHandler(form[field_key], modelKeyReduce, data) : isFunction(objectHandler) ? objectHandler(form[field_key], modelKeyReduce) : false;
    if (!use_handler && isObject(form[field_key]) && form[field_key].hasOwnProperty('content')) {
      var _data$modelKey, _content_data, _form$field_key3, _form$field_key4;
      //console.log('field_key', field_key)
      let content_data,
        data_content = modelKeySplit.length > 1 ? modelKeySplit.reduce((a, b) => a === null || a === void 0 ? void 0 : a[b], data) : data === null || data === void 0 || (_data$modelKey = data[modelKey]) === null || _data$modelKey === void 0 ? void 0 : _data$modelKey.content;
      //console.log('data_content', data_content)
      if (form[field_key].hierarchicalPopulation) {
        if (Array.isArray(data_content)) {
          content_data = [];
          data_content.forEach(contentItem => {
            let itemForm = new form[field_key].populationForm();
            PopulateFormFields(itemForm, contentItem);
            content_data.push(itemForm);
          });
        } else {
          content_data = new form[field_key].populationForm();
          PopulateFormFields(content_data, data_content);
        }
      } else content_data = data_content;
      //console.log('content_data', content_data)
      form[field_key].content = (_content_data = content_data) !== null && _content_data !== void 0 ? _content_data : form[field_key].default;
      if (form[field_key].populateOptionLikeContent) form[field_key].options = content_data;
      if (isFunction((_form$field_key3 = form[field_key]) === null || _form$field_key3 === void 0 || (_form$field_key3 = _form$field_key3.events) === null || _form$field_key3 === void 0 ? void 0 : _form$field_key3.onChange)) (_form$field_key4 = form[field_key]) === null || _form$field_key4 === void 0 || (_form$field_key4 = _form$field_key4.events) === null || _form$field_key4 === void 0 || _form$field_key4.onChange({
        value: form[field_key].content
      });
    }
  });
}
function sendGoogleTagEvent(pixel, event) {
  if (!window.dataLayer) {
    ;
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', pixel);
  }
  dataLayer.push(event);
}
function getNumberFromString(s, idx = 2) {
  var _exec;
  return (_exec = /(\D*)(\d+\.?\d*)(\D*)/.exec(s)) === null || _exec === void 0 ? void 0 : _exec[idx];
}
function convertDateToChunks(startDate, endDate, mode = 'm') {
  if (!startDate || !endDate) return [];
  let chunks = [];
  let to = new Date().getTimezoneOffset();
  let sd = new Date(new Date(startDate).setHours(0, 0, 0, 0) - to * 1000 * 60);
  let ed = new Date(new Date(endDate).setHours(0, 0, 0, 0) - to * 1000 * 60);
  if (mode === 'm') {
    sd = new Date(sd.setDate(1));
    ed = new Date(ed.setDate(1));
  }
  let osd = null;
  let msd = null;
  while (ed >= sd) {
    osd = new Date(sd);
    if (mode === 'd') sd = new Date(sd.setDate(osd.getDate() + 1));else if (mode === 'm') sd = new Date(sd.setMonth(sd.getMonth() + 1));
    msd = new Date(sd);
    chunks.push({
      chunk_start: osd,
      chunk_end: msd
    });
  }
  if (chunks.length < 2) {
    osd = new Date(sd);
    if (mode === 'd') {
      osd.setDate(osd.getDate() + 1);
      sd = new Date(sd.setDate(sd.getDate()));
    } else if (mode === 'm') {
      osd.setMonth(osd.getMonth() + 1);
      sd = new Date(sd.setMonth(sd.getMonth()));
    }
    chunks.push({
      chunk_start: sd,
      chunk_end: osd
    });
  }
  return chunks;
}
function getYoutubeVideoEmbed(url) {
  var _url$searchParams$get;
  url = new URL(url);
  url = (_url$searchParams$get = url.searchParams.get('v')) !== null && _url$searchParams$get !== void 0 ? _url$searchParams$get : url.pathname.replace('/', '');
  return `//www.youtube.com/embed/${url}`;
}
function getYoutubeVideoImage(url) {
  var _url$searchParams$get2;
  if (!isString(url)) return url;
  url = new URL(url);
  url = (_url$searchParams$get2 = url.searchParams.get('v')) !== null && _url$searchParams$get2 !== void 0 ? _url$searchParams$get2 : url.pathname.replace('/', '');
  return `https://img.youtube.com/vi/${url}/default.jpg`;
}
function getFieldName(lead, data, mode = 'g') {
  var _RegExp$exec;
  if (data) return (_RegExp$exec = new RegExp(`(\\w*)(${lead},|${lead}$)`, mode).exec(typeof data === 'object' ? Object.keys(data).toString() : data)) === null || _RegExp$exec === void 0 ? void 0 : _RegExp$exec[0].replace(',', '');
}
function FormatDate(date) {
  return new Date(date !== null && date !== void 0 ? date : '-').toLocaleDateString('en-EN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
}
function getFormData(formData = {}) {
  let data = [];
  if (formData) {
    Object.keys(formData).forEach(key => {
      var _formData$key;
      if (((_formData$key = formData[key]) === null || _formData$key === void 0 ? void 0 : _formData$key.fieldName) !== undefined && formData[key].toForm !== false) {
        var _formData$key2, _formData$key3, _formData$key6;
        if (((_formData$key2 = formData[key]) === null || _formData$key2 === void 0 ? void 0 : _formData$key2.content) instanceof Object && ((_formData$key3 = formData[key]) === null || _formData$key3 === void 0 ? void 0 : _formData$key3.type) === 'date') {
          if (formData[key].enumerable || formData[key].enumerable !== false) {
            var _formData$key4, _formData$key5;
            data.push({
              name: 'startDate',
              value: moment((_formData$key4 = formData[key]) === null || _formData$key4 === void 0 ? void 0 : _formData$key4.content['startDate']).format('Y-MM-DD 00:00:00')
            });
            data.push({
              name: 'endDate',
              value: moment((_formData$key5 = formData[key]) === null || _formData$key5 === void 0 ? void 0 : _formData$key5.content['endDate']).format('Y-MM-DD 23:59:59')
            });
          }
        } else if (((_formData$key6 = formData[key]) === null || _formData$key6 === void 0 ? void 0 : _formData$key6.type) === 'json') {
          var _formData$key7, _formData$key11;
          let json_data = (_formData$key7 = formData[key]) === null || _formData$key7 === void 0 ? void 0 : _formData$key7.content;
          if (formData[key].updateCheckedData) {
            if (formData[key].id === 'sale-page-form-offer-option') {
              var _formData$key8;
              formData[key].content.map(opt => {
                opt.OptionName.checked = formData[key].selected === opt.OptionName.content;
                return opt;
              });
              json_data = (_formData$key8 = formData[key]) === null || _formData$key8 === void 0 ? void 0 : _formData$key8.checked.sort((a, b) => a.OptionQuantity.content - b.OptionQuantity.content);
            } else if (formData[key].id === 'sale-page-form-offer-upsell') {
              var _formData$key9;
              formData[key].content.map(opt => {
                opt.UpSellNamePointer.checked = formData[key].checked.some(s => s.UpSellNamePointer.content === opt.UpSellNamePointer.content);
                return opt;
              });
              json_data = (_formData$key9 = formData[key]) === null || _formData$key9 === void 0 ? void 0 : _formData$key9.checked;
            } else if (formData[key].id === 'sale-page-form-offer-cross-sell') {
              var _formData$key10;
              formData[key].content.map(opt => {
                opt.CrossSellNamePointer.checked = formData[key].checked.some(s => s.CrossSellNamePointer.content === opt.CrossSellNamePointer.content);
                return opt;
              });
              json_data = (_formData$key10 = formData[key]) === null || _formData$key10 === void 0 ? void 0 : _formData$key10.checked;
            }
          }
          json_data = json_data.map(jsonObj => {
            Object.keys(jsonObj).forEach(key => {
              if (jsonObj[key].messages) {
                jsonObj[key].messages = {};
              }
              Object.keys(jsonObj[key]).forEach(subKey => {
                if (jsonObj[key][subKey] === undefined) jsonObj[key][subKey] = '';
              });
            });
            return jsonObj;
          });
          data.push({
            name: (_formData$key11 = formData[key]) === null || _formData$key11 === void 0 ? void 0 : _formData$key11.fieldName,
            value: JSON.stringify(json_data)
          });
        } else {
          var _formData$key12, _formData$key15;
          if (getType((_formData$key12 = formData[key]) === null || _formData$key12 === void 0 ? void 0 : _formData$key12.content) === 'Object') {
            var _formData$key13, _formData$key14;
            data.push({
              name: (_formData$key13 = formData[key]) === null || _formData$key13 === void 0 ? void 0 : _formData$key13.fieldName,
              value: (_formData$key14 = formData[key]) === null || _formData$key14 === void 0 || (_formData$key14 = _formData$key14.content) === null || _formData$key14 === void 0 || (_formData$key14 = _formData$key14.Id) === null || _formData$key14 === void 0 ? void 0 : _formData$key14.content
            });
          } else if (Array.isArray((_formData$key15 = formData[key]) === null || _formData$key15 === void 0 ? void 0 : _formData$key15.content)) {
            var _formData$key16, _formData$key17, _formData$key18;
            let convert_function = (_formData$key16 = formData[key]) === null || _formData$key16 === void 0 ? void 0 : _formData$key16.convertArrayToIds;
            data.push({
              name: (_formData$key17 = formData[key]) === null || _formData$key17 === void 0 ? void 0 : _formData$key17.fieldName,
              value: typeof convert_function === 'function' ? convert_function() : (_formData$key18 = formData[key]) === null || _formData$key18 === void 0 ? void 0 : _formData$key18.content
            });
          } else {
            var _formData$key19, _formData$key20, _formData$key21, _formData$key22;
            data.push({
              name: (_formData$key19 = formData[key]) === null || _formData$key19 === void 0 ? void 0 : _formData$key19.fieldName,
              value: (_formData$key20 = formData[key]) !== null && _formData$key20 !== void 0 && _formData$key20.content || ((_formData$key21 = formData[key]) === null || _formData$key21 === void 0 ? void 0 : _formData$key21.content) === 0 ? (_formData$key22 = formData[key]) === null || _formData$key22 === void 0 ? void 0 : _formData$key22.content : ''
            });
          }
        }
      }
    });
  }
  return data;
}
function emptyDeepMessages(entity) {
  if ((entity === null || entity === void 0 ? void 0 : entity.messages) !== undefined) entity.messages = [];
  isObject(entity) ? Object.keys(entity).forEach(k => emptyDeepMessages(entity[k])) : isArray(entity) ? entity.forEach(sub => emptyDeepMessages(sub)) : null;
}
function serializeObject(rawData, DataModel, dataParam = null) {
  if (!rawData) return null;
  if (!DataModel) return rawData;
  let dataModelInstance = isFunction(DataModel) ? new DataModel(dataParam, {
    rawModel: rawData
  }) : DataModel;
  if (!dataModelInstance) return null;
  Object.keys(dataModelInstance).forEach(key => {
    if (rawData[dataModelInstance[key].fieldName] !== undefined) {
      dataModelInstance[key].serialized = !!rawData[dataModelInstance[key].fieldName];
      if (dataModelInstance[key].model || dataModelInstance[key].dynamicModel) {
        if (Array.isArray(rawData[dataModelInstance[key].fieldName])) {
          let rawDataArray = [];
          rawData[dataModelInstance[key].fieldName].forEach(subObject => {
            let FieldModel = Function.isFunction(dataModelInstance[key].dynamicModel) ? dataModelInstance[key].dynamicModel(subObject) : dataModelInstance[key].model;
            return JsonMapper.isPrototypeOf(FieldModel) || JsonArrayMapper.isPrototypeOf(FieldModel) ? new FieldModel(subObject) : rawDataArray.push(serializeObject(subObject, FieldModel));
          });
          dataModelInstance[key].content = rawDataArray;
        } else if (isObject(rawData[dataModelInstance[key].fieldName])) {
          let FieldModel = Function.isFunction(dataModelInstance[key].dynamicModel) ? dataModelInstance[key].dynamicModel(rawData[dataModelInstance[key].fieldName]) : dataModelInstance[key].model;
          let fieldJsonData = rawData[dataModelInstance[key].fieldName];
          dataModelInstance[key].content = JsonMapper.isPrototypeOf(FieldModel) || JsonArrayMapper.isPrototypeOf(FieldModel) ? new FieldModel(fieldJsonData) : serializeObject(fieldJsonData, FieldModel);
        } else dataModelInstance[key].content = rawData[dataModelInstance[key].fieldName];
      } else if (dataModelInstance[key].type && dataModelInstance[key].type === 'json' && typeof rawData[dataModelInstance[key].fieldName] === 'string') {
        dataModelInstance[key].content = JSON.parse(rawData[dataModelInstance[key].fieldName]);
      } else dataModelInstance[key].content = rawData[dataModelInstance[key].fieldName];
    }
  });
  return dataModelInstance;
}
function permitted(permission) {
  return store.getters.authenticatedUserHasPermission(permission);
}
export function permittedSome(permission) {
  return store.getters.authenticatedUser instanceof User && store.getters.authenticatedUser.isSomePermitted(permission);
}
function permittedRole(roles) {
  let userRoleName = store.getters.getAuthUserRoleName;
  if (!userRoleName) return false;
  if (isEqual(roles, ['*'])) return true;
  if (!roles) return false;
  return roles.includes(userRoleName);
}
let levels = [{
  name: 'offer_levels.vip',
  points: 1000,
  level_sym: 'vip'
}, {
  name: 'offer_levels.level_3',
  points: 500,
  level_sym: 3
}, {
  name: 'offer_levels.level_2',
  points: 100,
  level_sym: 2
}, {
  name: 'offer_levels.level_1',
  points: 0,
  level_sym: 1
}];
let PERMISSIONS = {
  OVERVIEW: {
    ID: '0'
  },
  ORDERS: {
    ID: '1',
    IMPORT_ORDERS: {
      ID: '1.0'
    },
    EXPORT_ORDERS: {
      ID: '1.1'
    },
    MULTIPLE_ORDER_STATUS_CHANGE: {
      ID: '1.2'
    },
    MULTIPLE_ORDER_CALL_STATUS_CHANGE: {
      ID: '1.3'
    },
    VIEW_ORDER_DETAILS: {
      ID: '1.4',
      SEND_ORDER_TO_WAREHOUSE: {
        ID: '1.4.0'
      },
      ADD_ORDER_CALL_COMMENT: {
        ID: '1.4.1'
      },
      ADD_ORDER_PRIVATE_NOTE: {
        ID: '1.4.2'
      },
      ORDER_STATUS_CHANGE: {
        ID: '1.4.3',
        CONFIRM_ORDER: {
          ID: '1.4.3.0'
        },
        NO_ANSWER_ORDER: {
          ID: '1.4.3.1'
        },
        CANCEL_ORDER: {
          ID: '1.4.3.2'
        },
        DELIVER_ORDER: {
          ID: '1.4.3.3'
        },
        RETURN_ORDER: {
          ID: '1.4.3.4'
        },
        SHIP_ORDER: {
          ID: '1.4.3.5'
        }
      },
      SEND_ORDER_TO_SHEETS: {
        ID: '1.4.4'
      }
    }
  },
  TESTED_ORDERS: {
    ID: '2',
    SEND_TO_WAREHOUSE: {
      ID: '2.0'
    },
    MULTIPLE_TEST_ORDER_STATUS_CHANGE: {
      ID: '2.1'
    },
    MULTIPLE_TEST_ORDER_CALL_STATUS_CHANGE: {
      ID: '2.2'
    }
  },
  OFFER_REQUESTS: {
    ID: '3',
    CHANGE_CUSTOMER_DETAILS: {
      ID: '3.0'
    },
    DELETE_OFFER_REQUEST: {
      ID: '3.1'
    },
    CHANGE_OFFER_REQUEST_STATUS: {
      ID: '3.2'
    }
  },
  SALE_REPORTS: {
    ID: '4',
    VIEW_CHART: {
      ID: '4.0'
    },
    VIEW_STATS_BY_AFFILIATES: {
      ID: '4.1'
    },
    VIEW_STATS_BY_REFERRER: {
      ID: '4.2'
    },
    VIEW_STATS_BY_SALE_PAGE: {
      ID: '4.3'
    },
    VIEW_STATS_BY_OFFER: {
      ID: '4.4'
    },
    VIEW_STATS_BY_COUNTRY: {
      ID: '4.5'
    },
    VIEW_STATS_BY_WAREHOUSE: {
      ID: '4.6'
    },
    VIEW_STATS_BY_MANAGER: {
      ID: '4.7'
    },
    VIEW_STATS_BY_PRODUCT: {
      ID: '4.8'
    },
    VIEW_STATS_BY_CALL_AGENT: {
      ID: '4.9'
    },
    VIEW_STATS_BY_SELLER: {
      ID: '4.10'
    }
  },
  TRENDING: {
    ID: '5'
  },
  PRODUCTS: {
    ID: '6',
    CREATE: {
      ID: '6.0'
    },
    DUPLICATE: {
      ID: '6.1'
    },
    EDIT: {
      ID: '6.2'
    },
    DELETE: {
      ID: '6.3'
    },
    ADD_INVENTORY: {
      ID: '6.4'
    },
    DELETE_INVENTORY: {
      ID: '6.5'
    },
    VIEW_DETAILS: {
      ID: '6.6'
    },
    IMPORT_PRODUCT: {
      ID: '6.7',
      ALIEXPRESS: {
        ID: '6.7.0'
      },
      AMAZON: {
        ID: '6.7.1'
      },
      SHOPIFY: {
        ID: '6.7.2'
      }
    }
  },
  INVENTORY_OVERVIEW: {
    ID: '7'
  },
  OFFERS: {
    ID: '8',
    COD: {
      ID: '8.0',
      CREATE: {
        ID: '8.0.0'
      },
      DUPLICATE: {
        ID: '8.0.1'
      },
      EDIT: {
        ID: '8.0.2'
      },
      DELETE: {
        ID: '8.0.3'
      },
      VIEW_DETAILS: {
        ID: '8.0.4'
      },
      GENERATE_SALE_PAGE: {
        ID: '8.0.5'
      },
      GENERATE_PRE_SALE_PAGE: {
        ID: '8.0.6'
      }
    },
    PRE_PAID: {
      ID: '8.1',
      CREATE: {
        ID: '8.1.0'
      },
      DUPLICATE: {
        ID: '8.1.1'
      },
      EDIT: {
        ID: '8.1.2'
      },
      DELETE: {
        ID: '8.1.3'
      },
      VIEW_DETAILS: {
        ID: '8.1.4'
      },
      GENERATE_SALE_PAGE: {
        ID: '8.1.5'
      },
      GENERATE_PRE_SALE_PAGE: {
        ID: '8.1.6'
      }
    }
  },
  SALE_PAGES: {
    ID: '9',
    ORIGINAL: {
      ID: '9.0',
      CREATE: {
        ID: '9.0.0',
        STATUS: {
          ID: '9.0.0.0'
        },
        DOMAIN: {
          ID: '9.0.0.1'
        },
        OFFER: {
          ID: '9.0.0.2'
        },
        LANGUAGE: {
          ID: '9.0.0.3'
        },
        GENERALE_DETAILS: {
          ID: '9.0.0.4'
        },
        ADDONS: {
          ID: '9.0.0.5'
        },
        BLOCKS: {
          ID: '9.0.0.6'
        },
        CHECKOUT_OPTIONS: {
          ID: '9.0.0.7'
        },
        UPSELLS_AND_CROSS_SELLS: {
          ID: '9.0.0.8'
        }
      },
      EDIT: {
        ID: '9.0.1',
        STATUS: {
          ID: '9.0.1.0'
        },
        DOMAIN: {
          ID: '9.0.1.1'
        },
        OFFER: {
          ID: '9.0.1.2'
        },
        LANGUAGE: {
          ID: '9.0.1.3'
        },
        GENERALE_DETAILS: {
          ID: '9.0.1.4'
        },
        ADDONS: {
          ID: '9.0.1.5'
        },
        BLOCKS: {
          ID: '9.0.1.6'
        },
        CHECKOUT_OPTIONS: {
          ID: '9.0.1.7'
        },
        UPSELLS_AND_CROSS_SELLS: {
          ID: '9.0.1.8'
        }
      },
      DUPLICATE: {
        ID: '9.0.2'
      },
      DELETE: {
        ID: '9.0.3'
      }
    },
    GENERATED: {
      ID: '9.1',
      EDIT: {
        ID: '9.1.0',
        STATUS: {
          ID: '9.1.0.0'
        },
        DOMAIN: {
          ID: '9.1.0.1'
        },
        OFFER: {
          ID: '9.1.0.2'
        },
        LANGUAGE: {
          ID: '9.1.0.3'
        },
        GENERALE_DETAILS: {
          ID: '9.1.0.4'
        },
        ADDONS: {
          ID: '9.1.0.5'
        },
        BLOCKS: {
          ID: '9.1.0.6'
        },
        CHECKOUT_OPTIONS: {
          ID: '9.1.0.7'
        },
        UPSELLS_AND_CROSS_SELLS: {
          ID: '9.1.0.8'
        }
      },
      DUPLICATE: {
        ID: '9.1.1'
      },
      DELETE: {
        ID: '9.1.2'
      }
    }
  },
  PRE_SALE_PAGES: {
    ID: '10',
    ORIGINAL: {
      ID: '10.0',
      CREATE: {
        ID: '10.0.0',
        STATUS: {
          ID: '10.0.0.0'
        },
        DOMAIN: {
          ID: '10.0.0.1'
        },
        SALE_PAGE: {
          ID: '10.0.0.2'
        },
        TITLE: {
          ID: '10.0.0.3'
        },
        ADDONS: {
          ID: '10.0.0.4'
        },
        BLOCKS: {
          ID: '10.0.0.5'
        }
      },
      EDIT: {
        ID: '10.0.1',
        STATUS: {
          ID: '10.0.0.0'
        },
        DOMAIN: {
          ID: '10.0.0.1'
        },
        SALE_PAGE: {
          ID: '10.0.0.2'
        },
        TITLE: {
          ID: '10.0.0.3'
        },
        ADDONS: {
          ID: '10.0.0.4'
        },
        BLOCKS: {
          ID: '10.0.0.5'
        }
      },
      DELETE: {
        ID: '10.0.2'
      },
      DUPLICATE: {
        ID: '10.0.3'
      }
    },
    GENERATED: {
      ID: '10.1',
      EDIT: {
        ID: '10.1.0',
        STATUS: {
          ID: '10.1.0.0'
        },
        DOMAIN: {
          ID: '10.1.0.1'
        },
        SALE_PAGE: {
          ID: '10.1.0.2'
        },
        TITLE: {
          ID: '10.1.0.3'
        },
        ADDONS: {
          ID: '10.1.0.4'
        },
        BLOCKS: {
          ID: '10.1.0.5'
        }
      },
      DELETE: {
        ID: '10.1.1'
      },
      DUPLICATE: {
        ID: '10.1.2'
      }
    }
  },
  STORE: {
    ID: '11',
    DOMAINS: {
      ID: '11.3',
      CREATE: {
        ID: '11.3.0',
        UP_TO_TWO: '11.3.0.0',
        UP_TO_TEN: '11.3.0.1',
        LANGUAGE_TYPE: {
          ID: '11.3.0.2',
          MULTIPLE_LANGUAGES: {
            ID: '11.3.0.2.0'
          }
        }
      },
      EDIT: {
        ID: '11.3.1',
        LANGUAGE_TYPE: {
          ID: '11.3.1.0',
          MULTIPLE_LANGUAGES: {
            ID: '11.3.1.0.0'
          }
        }
      },
      DELETE: {
        ID: '11.3.2'
      }
    },
    STORES: {
      ID: '11.0',
      EDIT: {
        ID: '11.0.0',
        LANGUAGE_TYPE: {
          ID: '11.0.0.0',
          MULTIPLE_LANGUAGE: {
            ID: '11.0.0.0.0'
          }
        }
      },
      CREATE: {
        ID: '11.0.1'
      },
      DELETE: {
        ID: '11.0.2'
      }
    },
    STORE_PAGES: {
      ID: '11.1',
      EDIT: {
        ID: '11.1.0',
        BLOCKS: {
          ID: '11.1.0.0'
        }
      },
      DELETE: {
        ID: '11.1.1'
      }
    },
    STORE_LAYOUTS: {
      ID: '11.2',
      CREATE: {
        ID: '11.2.0'
      },
      EDIT: {
        ID: '11.2.1'
      },
      DELETE: {
        ID: '11.2.2'
      },
      DUPLICATE: {
        ID: '11.2.3'
      }
    },
    LIBRARY: {
      ID: '11.4'
    }
  },
  BUSINESS_MANAGERS: {
    ID: '13',
    WOO_COMMERCE: {
      ID: '13.0',
      ADD_DOMAIN: {
        ID: '13.0.0'
      },
      MAP_DOMAIN_OFFERS_WITH_WOO_COMMERCE_PRODUCTS: {
        ID: '13.0.1',
        SAVE: {
          ID: '13.0.1.0'
        }
      },
      CONNECT_DOMAIN_TO_WOO_COMMERCE: {
        ID: '13.0.2'
      },
      DELETE_DOMAIN: {
        ID: '13.0.3'
      }
    },
    GOOGLE_SHOPPING: {
      ID: '13.1',
      GENERATE_FEED: {
        ID: '13.1.0'
      },
      SAVE_DOMAIN_VERIFICATION_STRING: {
        ID: '13.1.1'
      },
      REFRESH_FEED_PRODUCTS: {
        ID: '13.1.2'
      },
      DELETE_FEED: {
        ID: '13.1.3'
      },
      VIEW_FEED_DETAILS: {
        ID: '13.1.4',
        SAVE: {
          ID: '13.1.4.0'
        }
      }
    },
    FACEBOOK_SHOPPING: {
      ID: '13.2',
      GENERATE_FEED: {
        ID: '13.2.0'
      },
      SAVE_DOMAIN_VERIFICATION_STRING: {
        ID: '13.2.1'
      },
      REFRESH_FEED_PRODUCTS: {
        ID: '13.2.2'
      },
      DELETE_FEED: {
        ID: '13.2.3'
      },
      VIEW_FEED_DETAILS: {
        ID: '13.2.4',
        SAVE: {
          ID: '13.2.4.0'
        }
      }
    },
    GOOGLE_SHEET: {
      ID: '13.3',
      CREATE_SHEET: {
        ID: '13.3.0'
      },
      EDIT_SHEET: {
        ID: '13.3.1'
      },
      DELETE_SHEET: {
        ID: '13.3.2'
      }
    }
  },
  INVOICES: {
    ID: '15',
    ELIGIBLE_ORDERS: {
      ID: '15.0',
      GENERATE_PAYOUT: {
        ID: '15.0.0'
      },
      GENERATE_REMITTANCE: {
        ID: '15.0.1'
      },
      GENERATE_EXPENSES: {
        ID: '15.0.2'
      },
      GENERATE_COMMISSIONS: {
        ID: '15.0.3'
      }
    },
    PAYOUTS: {
      ID: '15.1',
      PAY: {
        ID: '15.1.0'
      },
      VIEW_DETAILS: {
        ID: '15.1.1',
        DELETE_ORDER_FROM_INVOICE: {
          ID: '5.1.1.0'
        },
        DOWNLOAD_AS_EXCEL: {
          ID: '5.1.1.1'
        },
        DOWNLOAD_AS_PDF: {
          ID: '5.1.1.2'
        }
      },
      DELETE: {
        ID: '15.1.2'
      }
    },
    REMITTANCE: {
      ID: '15.2',
      PAY: {
        ID: '15.2.0'
      },
      VIEW_DETAILS: {
        ID: '15.2.1',
        DELETE_ORDER_FROM_INVOICE: {
          ID: '5.2.1.0'
        },
        DOWNLOAD_AS_EXCEL: {
          ID: '5.2.1.1'
        },
        DOWNLOAD_AS_PDF: {
          ID: '5.2.1.2'
        }
      },
      DELETE: {
        ID: '15.2.2'
      }
    },
    EXPENSES: {
      ID: '15.3',
      PAY: {
        ID: '15.3.0'
      },
      VIEW_DETAILS: {
        ID: '15.3.1',
        DELETE_ORDER_FROM_INVOICE: {
          ID: '5.3.1.0'
        },
        DOWNLOAD_AS_EXCEL: {
          ID: '5.3.1.1'
        },
        DOWNLOAD_AS_PDF: {
          ID: '5.3.1.2'
        }
      },
      DELETE: {
        ID: '15.3.2'
      }
    },
    ADVERTISER_COMMISSION: {
      ID: '15.4',
      VIEW_DETAILS: {
        ID: '15.4.0',
        DELETE_ORDER_FROM_INVOICE: {
          ID: '15.4.0.0'
        },
        DOWNLOAD_AS_EXCEL: {
          ID: '15.4.0.1'
        },
        DOWNLOAD_AS_PDF: {
          ID: '15.4.0.2'
        }
      },
      PAY: {
        ID: '15.4.1'
      },
      DELETE: {
        ID: '15.4.2'
      }
    },
    REFERRALS: {
      ID: '15.5',
      VIEW_DETAILS: {
        ID: '15.5.0'
      },
      PAY: {
        ID: '15.5.1'
      },
      DELETE: {
        ID: '15.5.2'
      }
    },
    SUBSCRIPTION_INVOICES: {
      ID: '15.6'
    },
    SETTINGS: {
      ID: '15.7',
      ACCOUNT_DETAILS: {
        ID: '15.7.0'
      },
      PAYMENT_PROCESSORS: {
        ID: '15.7.1',
        ADD: {
          ID: '15.7.1.0'
        },
        EDIT: {
          ID: '15.7.1.1'
        },
        DELETE: {
          ID: '15.7.1.2'
        },
        ACTIVATE: {
          ID: '15.7.1.3'
        }
      },
      PAYMENT_INFO: {
        ID: '15.7.2',
        SAVE: {
          ID: '15.7.2.0'
        }
      },
      IDENTITY_VERIFICATION: {
        ID: '15.7.3'
      },
      TRACKING_DATA: {
        ID: '15.7.4',
        SAVE: {
          ID: '15.7.4.0'
        }
      },
      OTHER_SETTINGS: {
        ID: '15.7.5',
        WHATS_APP: {
          ID: '15.7.5.0'
        }
      }
    }
  },
  ACCOUNTING: {
    ID: '16',
    VIEW_CHART: {
      ID: '16.0'
    },
    VIEW_STATS_BY_AFFILIATES: {
      ID: '16.1'
    },
    VIEW_STATS_BY_REFERRER: {
      ID: '16.2'
    },
    VIEW_STATS_BY_SALE_PAGE: {
      ID: '16.3'
    },
    VIEW_STATS_BY_OFFER: {
      ID: '16.4'
    },
    VIEW_STATS_BY_COUNTRY: {
      ID: '16.5'
    },
    VIEW_STATS_BY_WAREHOUSE: {
      ID: '16.6'
    },
    VIEW_STATS_BY_MANAGER: {
      ID: '16.7'
    },
    VIEW_STATS_BY_PRODUCT: {
      ID: '16.8'
    },
    VIEW_STATS_BY_CALL_AGENT: {
      ID: '16.9'
    },
    VIEW_STATS_BY_SELLER: {
      ID: '16.10'
    }
  },
  NOTIFICATIONS: {
    ID: '17',
    CREATE: {
      ID: '17.0'
    },
    VIEW: {
      ID: '17.1'
    }
  },
  SUPPORT: {
    ID: '19',
    FAQS: {
      ID: '19.0',
      CREATE: {
        ID: '19.0.0',
        CREATE_CATEGORY: {
          ID: '19.0.0.0'
        }
      },
      EDIT: {
        ID: '19.0.1',
        CREATE_CATEGORY: {
          ID: '19.0.1.0'
        }
      },
      DELETE: {
        ID: '19.0.2'
      },
      DELETE_FAQ_CATEGORY: {
        ID: '19.0.3'
      },
      EDIT_FAQ_CATEGORY: {
        ID: '19.0.4'
      },
      TOGGLE_FAQ_CATEGORY: {
        ID: '19.0.5'
      },
      VIEW: {
        ID: '19.0.6'
      }
    },
    TUTORIALS: {
      ID: '19.2',
      VIEW: {
        ID: '19.2.6'
      },
      CREATE: {
        ID: '19.2.0',
        CREATE_CATEGORY: {
          ID: '19.2.0.0'
        }
      },
      EDIT: {
        ID: '19.2.1',
        CREATE_CATEGORY: {
          ID: '19.2.1.0'
        }
      },
      DELETE: {
        ID: '19.2.2'
      },
      TOGGLE_PUBLISH_CATEGORY: {
        ID: '19.2.3'
      },
      EDIT_CATEGORY: {
        ID: '19.2.4'
      },
      DELETE_CATEGORY: {
        ID: '19.2.5'
      }
    },
    TICKETS: {
      ID: '19.1',
      CREATE: {
        ID: '19.1.0'
      },
      CREATE_TICKET_MESSAGE: {
        ID: '19.1.1'
      }
    },
    MANAGER_INFO: {
      ID: '19.3'
    },
    WHATSAPP_BUTTON: {
      ID: '19.4'
    }
  },
  WAREHOUSES_SETTINGS: {
    ID: '21',
    WAREHOUSES: {
      ID: '21.0',
      CREATE: {
        ID: '21.0.0',
        IMAGE: {
          ID: '21.0.0.0'
        },
        STATUS: {
          ID: '21.0.0.1'
        },
        NAME: {
          ID: '21.0.0.2'
        },
        USERNAME: {
          ID: '21.0.0.3'
        },
        CONTACT_NAME: {
          ID: '21.0.0.4'
        },
        EMAIL: {
          ID: '21.0.0.5'
        },
        PASSWORD: {
          ID: '21.0.0.6'
        },
        PHONE: {
          ID: '21.0.0.7'
        },
        SKYPE_ID: {
          ID: '21.0.0.8'
        },
        COUNTRY_PRICES: {
          ID: '21.0.0.9'
        },
        ACTIVATE_CALL_CENTER: {
          ID: '21.0.0.10'
        },
        CALL_AGENT_FULL_NAME: {
          ID: '21.0.0.11'
        },
        CALL_AGENT_COMPANY_NAME: {
          ID: '21.0.0.12'
        },
        CALL_AGENT_COUNTRY: {
          ID: '21.0.0.13'
        },
        CALL_AGENT_USERNAME: {
          ID: '21.0.0.14'
        },
        CALL_AGENT_EMAIL: {
          ID: '21.0.0.15'
        },
        CALL_AGENT_PHONE: {
          ID: '21.0.0.16'
        },
        CALL_AGENT_PASSWORD: {
          ID: '21.0.0.17'
        },
        CALL_AGENT_LANGUAGE: {
          ID: '21.0.0.18'
        },
        OWNER: {
          ID: '21.0.0.19'
        }
      },
      EDIT: {
        ID: '21.0.1',
        IMAGE: {
          ID: '21.0.1.0'
        },
        STATUS: {
          ID: '21.0.1.1'
        },
        NAME: {
          ID: '21.0.1.2'
        },
        USERNAME: {
          ID: '21.0.1.3'
        },
        CONTACT_NAME: {
          ID: '21.0.1.3'
        },
        EMAIL: {
          ID: '21.0.1.5'
        },
        PASSWORD: {
          ID: '21.0.1.6'
        },
        PHONE: {
          ID: '21.0.1.7'
        },
        SKYPE_ID: {
          ID: '21.0.1.8'
        },
        COUNTRY_PRICES: {
          ID: '21.0.1.9'
        },
        ACTIVATE_CALL_CENTER: {
          ID: '21.0.1.10'
        },
        CALL_AGENT_FULL_NAME: {
          ID: '21.0.1.11'
        },
        CALL_AGENT_COMPANY_NAME: {
          ID: '21.0.1.12'
        },
        CALL_AGENT_COUNTRY: {
          ID: '21.0.1.13'
        },
        CALL_AGENT_USERNAME: {
          ID: '21.0.1.14'
        },
        CALL_AGENT_EMAIL: {
          ID: '21.0.1.15'
        },
        CALL_AGENT_PHONE: {
          ID: '21.0.1.16'
        },
        CALL_AGENT_PASSWORD: {
          ID: '21.0.1.17'
        },
        CALL_AGENT_LANGUAGE: {
          ID: '21.0.1.18'
        },
        OWNER: {
          ID: '21.0.1.19'
        }
      },
      MULTIPLE_WAREHOUSE_ACTIVATION: {
        ID: '21.0.2'
      }
    },
    INVENTORY: {
      ID: '21.1'
    },
    EXTERNAL_API: {
      ID: '21.2',
      CREATE: {
        ID: '21.2.0'
      },
      UPDATE: {
        ID: '21.2.1'
      },
      DELETE: {
        ID: '21.2.2'
      }
    }
  },
  CALL_CENTERS: {
    ID: '22',
    CREATE: {
      ID: '22.0'
    },
    EDIT: {
      ID: '22.1'
    },
    MULTIPLE_CALL_CENTER_ACTIVATION: {
      ID: '22.2'
    }
  },
  ADVERTISERS: {
    ID: '23',
    CREATE: {
      ID: '23.0'
    },
    EDIT: {
      ID: '23.1'
    },
    MULTIPLE_ADVERTISER_ACTIVATION: {
      ID: '23.2'
    }
  },
  AFFILIATES: {
    ID: '24',
    MULTIPLE_ACTIVATION: {
      ID: '24.0'
    },
    MULTIPLE_AFFILIATE_MANAGER_ASSIGNMENT: {
      ID: '24.1'
    }
  },
  REFERRALS_PROGRAM: {
    ID: '25',
    LINK: {
      ID: '25.0'
    },
    INVOICES: {
      ID: '25.1'
    },
    PAYOUTS: {
      ID: '25.2',
      PAY_INVOICES: {
        ID: '25.2.0'
      },
      VIEW_INVOICES: {
        ID: '25.2.1'
      },
      DELETE: {
        ID: '25.2.2'
      }
    }
  },
  USERS: {
    ID: '26',
    USER_ACCOUNTS: {
      ID: '26.0',
      MANAGE_USERS: {
        ID: '26.0.0',
        CREATE_USER: {
          ID: '26.0.0.0'
        },
        EDIT_USER: {
          ID: '26.0.0.1'
        },
        MULTIPLE_STATUS_CHANGE: {
          ID: '26.0.0.2'
        }
      },
      MANAGE_ROLES: {
        ID: '26.0.1',
        ADD_PERMISSIONS_TO_ROLE: {
          ID: '26.0.1.0'
        },
        REMOVE_PERMISSION_FROM_ROLE: {
          ID: '26.0.1.1'
        },
        ADD_PERMISSIONS_TO_USER: {
          ID: '26.0.1.2'
        },
        REMOVE_PERMISSION_FROM_USER: {
          ID: '26.0.1.3'
        }
      },
      MANAGE_PLAN: {
        ID: '26.0.2',
        UPDATE_PLAN_PERMISSIONS: {
          ID: '26.0.2.0'
        }
      }
    },
    IDENTITY_VERIFICATION: {
      ID: '26.1',
      VERIFY_IDENTITY_VERIFICATION: {
        ID: '26.1.0'
      }
    }
  },
  ACTIVITY_LOGS: {
    ID: '28'
  },
  PRODUCT_SALE_PAGES: {
    ID: '29',
    CREATE: {
      ID: '29.0',
      STATUS: {
        ID: '29.0.0'
      },
      DOMAIN: {
        ID: '29.0.1'
      },
      PRODUCT: {
        ID: '29.0.2'
      },
      LANGUAGE: {
        ID: '29.0.3'
      },
      GENERALE_DETAILS: {
        ID: '29.0.4'
      },
      ADDONS: {
        ID: '29.0.5'
      },
      BLOCKS: {
        ID: '29.0.6'
      },
      CHECKOUT_OPTIONS: {
        ID: '29.0.7'
      },
      UPSELLS_AND_CROSS_SELLS: {
        ID: '29.0.8'
      }
    },
    EDIT: {
      ID: '29.1',
      STATUS: {
        ID: '29.1.0'
      },
      DOMAIN: {
        ID: '29.1.1'
      },
      PRODUCT: {
        ID: '29.1.2'
      },
      LANGUAGE: {
        ID: '29.1.3'
      },
      GENERALE_DETAILS: {
        ID: '29.1.4'
      },
      ADDONS: {
        ID: '29.1.5'
      },
      BLOCKS: {
        ID: '29.1.6'
      },
      CHECKOUT_OPTIONS: {
        ID: '29.1.7'
      },
      UPSELLS_AND_CROSS_SELLS: {
        ID: '29.1.8'
      }
    },
    DUPLICATE: {
      ID: '29.2'
    },
    DELETE: {
      ID: '29.3'
    },
    GENERATE_BLOCKS_WITH_AI: {
      ID: '29.4',
      CHAT_GPT_4O_MINI: {
        ID: '29.4.0'
      },
      CHAT_GPT_4O: {
        ID: '29.4.1'
      },
      CHAT_GPT_4O_TURBO: {
        ID: '29.4.2'
      }
    },
    CREATE_BY_AI: {
      ID: '29.5',
      DOMAIN: {
        ID: '29.5.0'
      },
      PRODUCT: {
        ID: '29.5.1'
      },
      INVENTORY_COUNTRY: {
        ID: '29.5.2'
      },
      COUNTRY_SELECT_TYPE: {
        ID: '29.5.3'
      },
      SHIPPING_COUNTRIES: {
        ID: '29.5.4'
      },
      DEFAULT_CURRENCY: {
        ID: '29.5.5'
      },
      CUSTOM_CURRENCY: {
        ID: '29.5.6'
      },
      LANGUAGE: {
        ID: '29.5.7'
      }
    }
  }
};
let permissions = {
  // global permissions
  OVERVIEW: 'overview',
  BUSINESS_MANAGERS: 'applications',
  COD_OFFERS: 'cod-offers',
  PREPAID_OFFERS: 'prepaid-offer',
  VIP_OFFERS: 'vip-offer',
  SALES_PAGES: 'sale-page',
  VIEW_STORE_PAGES: 'view-store-pages',
  ORIGINAL_SALES_PAGES: 'original-sale-page',
  ORIGINAL_PRE_SELL_PAGES: 'original-pre-sell-page',
  ORDERS: 'order',
  SALES_REPORTS: 'sale-report',
  TRENDING: 'trending',
  SETTINGS: 'settings',
  PAYMENTS: 'payment',
  NOTIFICATIONS: 'notification',
  TUTORIALS: 'tutorial',
  SUPPORT: 'support',
  WAREHOUSE: 'warehouse',
  PRODUCT: 'product',
  INVENTORY_OVERVIEW: 'inventory-overview',
  SELLERS: 'seller',
  REFERRAL_PROGRAM: 'referral_program',
  ACTIVITY_LOGS: 'activity-log',
  ACCOUNTING: 'accounting',
  USER: 'user',
  TESTED_ORDERS: 'tested-order',
  WAREHOUSE_PAYMENTS: 'warehouse-payment',
  SELLER_PAYMENTS: 'seller-payment',
  LIBRARY: 'library',
  LEADS: 'leads',
  EXPORT_ORDER: 'export-orders',
  INVOICES_PENDING: 'invoice-pending-orders',
  INVOICES_PAYOUT: 'invoice-payouts',
  INVOICES_REMITTANCE: 'invoice-remittance',
  INVOICES_COMMISSION: 'invoice-commission',
  INVOICES_REFERRAL_COMMISSION: 'invoice-referral-commission',
  INVOICES_EXPENSES: 'invoice-expenses',
  DOMAIN_NAMES: 'domain-names',
  CALL_AGENT: 'call-center',
  ADVERTISER: 'advertiser',
  // Partial permissions

  // Business Managers
  ADVANCED_APPS: 'advanced-apps',
  WOOCOMMERCE_MANAGER: 'woocommerce-manager',
  GOOGLE_SHOPPING: 'google-shopping',
  FACEBOOK_SHOPPING: 'facebook-shopping',
  // Store Pages
  EDIT_STORE_PAGE: 'edit-store-page',
  // Network Sdks
  VIEW_NETWORK_SDK_ACCOUNTS: 'view-network-sdk-accounts',
  EXTERNAL_API_INTEGRATION: 'external-api-integration',
  // Offer
  OFFER_OVERVIEW: 'offer_overview',
  OFFER_CREATIVES: 'offer_creatives',
  OFFER_PIXELS: 'offer_pixels',
  OFFER_TRACKING: 'offer_tracking',
  SHOW_COD_OFFERS: 'show-cod-offers',
  CREATE_COD_OFFER: 'create-cod-offer',
  UPDATE_COD_OFFER: 'update-cod-offer',
  DELETE_COD_OFFER: 'delete-cod-offer',
  SHOW_PREPAID_OFFERS: 'show-prepaid-offers',
  CREATE_PREPAID_OFFER: 'create-prepaid-offer',
  UPDATE_PREPAID_OFFER: 'update-prepaid-offer',
  DELETE_PREPAID_OFFER: 'delete-prepaid-offer',
  REQUEST_OFFER: 'request-offer',
  OFFER_REQUEST_PAGE: 'offer-request-page',
  // Product
  SHOW_PRODUCTS: 'show-products',
  CREATE_PRODUCT: 'create-product',
  UPDATE_PRODUCT: 'update-product',
  DELETE_PRODUCT: 'delete-product',
  // Inventories
  INVENTORIES: 'inventories',
  INVENTORY_HISTORY: 'inventory-history',
  INVENTORY_MINI_OVERVIEW: 'inventory-mini-overview',
  SHOW_INVENTORIES: 'show-inventories',
  CREATE_INVENTORY: 'create-inventory',
  DELETE_INVENTORY: 'delete-inventory',
  // Warehouse
  CREATE_WAREHOUSE: 'create-warehouse',
  UPDATE_WAREHOUSE: 'update-warehouse',
  SHOW_WAREHOUSES: 'show-warehouses',
  DELETE_WAREHOUSE: 'delete-warehouse',
  EDIT_WAREHOUSE: 'edit-warehouse',
  WAREHOUSE_NETWORK_ACCOUNT: 'warehouse-network-account',
  // Advertiser
  CREATE_ADVERTISER: 'create-advertiser',
  UPDATE_ADVERTISER: 'update-advertiser',
  SHOW_ADVERTISERS: 'show-advertiser',
  DELETE_ADVERTISER: 'delete-advertiser',
  EDIT_ADVERTISER: 'edit-advertiser',
  ACTIVATE_ADVERTISER: 'activate-advertiser',
  // seller
  ACTIVATE_SELLER: 'activate-seller',
  ASSIGN_SELLER_MANAGER: 'assign-manager',
  // Tutorial
  CREATE_TUTORIAL: 'create-tutorial',
  UPDATE_TUTORIAL: 'update-tutorial',
  DELETE_TUTORIAL: 'delete-tutorial',
  UPDATE_TUTORIAL_CATEGORY: 'update-tutorial-category',
  DELETE_TUTORIAL_CATEGORY: 'delete-tutorial-category',
  PUBLISH_CATEGORY: 'publish-tutorial-category',
  // User
  CREATE_USER: 'create-user',
  UPDATE_USER: 'update-user',
  SHOW_USERS: 'show-users',
  MANAGE_ROLES: 'manage-roles',
  ADD_PERMISSION_TO_ROLE: 'add-permission-to-role',
  REMOVE_PERMISSION_FROM_ROLE: 'remove-permission-from-role',
  ADD_PERMISSION_TO_ROLE_USER: 'add-permission-to-role-user',
  REMOVE_PERMISSION_FROM_ROLE_USER: 'remove-permission-from-role-user',
  USERS_SECTION: 'users-section',
  USERS_ACCOUNTS: 'users-accounts',
  ID_VERIFICATIONS: 'id-verifications',
  // Notification
  CREATE_NOTIFICATION: 'create_notification',
  // Faq
  CREATE_FAQ: 'create-faq',
  UPDATE_FAQ: 'update-faq',
  DELETE_FAQ: 'delete-faq',
  UPDATE_FAQ_CATEGORY: 'update-faq-category',
  DELETE_FAQ_CATEGORY: 'delete-faq-category',
  PUBLISH_FAQ_CATEGORY: 'publish_faq_category',
  // image Library
  DELETE_IMAGE: 'delete-library-image',
  // Sale page
  CREATE_SALE_PAGE: 'create-sale-page',
  DUPLICATE_SALE_PAGE: 'duplicate-sale-page',
  DELETE_SALE_PAGE: 'delete-sale-page',
  UPDATE_SALE_PAGE: 'update-sale-page',
  PREVIEW_SALE_PAGE: 'preview-sale-page',
  EDIT_SALE_PAGE_BLOCKS: 'edit-sale-page-blocks',
  EDIT_UPSELLS: 'edit-upsells',
  EDIT_CROSS_SELLS: 'edit-cross-sells',
  EDIT_OFFER_OPTIONS: 'edit-offer-options',
  EDIT_SALE_PAGE_GENERAL_INFO: 'edit-sale-page-general-info',
  PAGE_BLOCK_PLACEMENT: 'page-block-placement',
  ACTIVATE_SALE_PAGE: 'activate-sale-page',
  UPDATE_SALE_PAGE_PIXELS: 'update-sale-page-pixels',
  UPDATE_SALE_PAGE_ADDONS: 'update-sale-page-addons',
  AI_SALE_BLOCKS_GENERATION: 'ai-sale-blocks-generation',
  GENERATE_SALE_PAGE: 'generate-sale-page',
  //Product Sale page
  VIEW_PRODUCT_SALE_PAGE: 'view-product-sale-page',
  CREATE_PRODUCT_SALE_PAGE: 'create-product-sale-page',
  UPDATE_PRODUCT_SALE_PAGE: 'update-product-sale-page',
  DELETE_PRODUCT_SALE_PAGE: 'delete-product-sale-page',
  // Pre-sell page
  PRE_SELL_PAGE: 'pre-sell-page',
  CREATE_PRE_SELL_PAGE: 'create-pre-sell-page',
  UPDATE_PROTO_PRE_SELL_PAGE: 'update-proto-pre-sell-page',
  UPDATE_PROTO_GENERAL_PRE_SELL_PAGE: 'update-proto-general-pre-sell-page',
  UPDATE_INSTANCE_PRE_SELL_PAGE: 'update-instance-pre-sell-page',
  UPDATE_INSTANCE_GENERAL_PRE_SELL_PAGE: 'update-instance-general-pre-sell-page',
  DELETE_PROTO_PRE_SELL_PAGE: 'delete-proto-pre-sell-page',
  DELETE_INSTANCE_PRE_SELL_PAGE: 'delete-instance-pre-sell-page',
  FILTER_PROTO_PRE_SELL_PAGE: 'delete-proto-pre-sell-page',
  FILTER_INSTANCE_PRE_SELL_PAGE: 'delete-instance-pre-sell-page',
  PRE_SELL_PAGE_USER_FILTER: 'pre-sell-page-user-filter',
  PRE_SELL_PAGE_OFFER_FILTER: 'pre-sell-page-offer-filter',
  UPDATE_PROTO_PRE_SELL_PAGE_BLOCKS: 'update-proto-pre-sell-page-blocks',
  UPDATE_INSTANCE_PRE_SELL_PAGE_BLOCKS: 'update-instance-pre-sell-page-blocks',
  DUPLICATE_PROTO_PRE_SELL_PAGE: 'duplicate-proto-pre-sell-page',
  DUPLICATE_INSTANCE_PRE_SELL_PAGE: 'duplicate-instance-pre-sell-page',
  GENERATE_PRE_SELL_PAGE: 'generate-pre-sell-page',
  // Order
  NO_ANSWER_ORDER: 'no-answer',
  CREATE_ORDER: 'create-order',
  UPDATE_ORDER: 'update-order',
  CANCEL_ORDER: 'cancel-order',
  SHIP_ORDER: 'ship-order',
  DELIVER_ORDER: 'deliver-order',
  CONFIRM_ORDER: 'confirm-order',
  RETURN_ORDER: 'return-order',
  DELETE_ORDER: 'delete-order',
  SHOW_ORDERS: 'show-orders',
  SHOW_ORDER_MORE_INFO: 'show-order-more-info',
  SHOW_TEST_ORDERS: 'show-test-orders',
  SHOW_TEST_ORDER_MORE_INFO: 'show-test-order-more-info',
  SHOW_ORDER_CALLS: 'show-orders-calls',
  ADD_ORDER_CALLS: 'add-orders-calls',
  ADD_ORDER_NOTES: 'add-orders-notes',
  SHOW_ORDER_NOTES: 'show-orders-notes',
  // Tested order
  CREATE_TESTED_ORDER: 'create-order',
  UPDATE_TESTED_ORDER: 'update-order',
  DELETE_TESTED_ORDER: 'delete-order',
  SHOW_TESTED_ORDERS: 'show-orders',
  SHOW_TESTED_ORDER_MORE_INFO: 'show-order-more-info',
  // Ticket
  CREATE_TICKET: 'create-ticket',
  CLOSE_TICKET: 'close-ticket',
  SHOW_TICKET: 'show-ticket',
  // Call agent
  CREATE_CALL_AGENT: 'create-call-agent',
  UPDATE_CALL_AGENT: 'update-call-agent',
  SHOW_CALL_AGENT: 'show-call-agent',
  ASSIGN_PRODUCT_CALL_AGENT: 'assign-product-call-agent',
  // Settings
  SAVE_PIXELS: 'settings-save-pixel',
  PAYMENT_INFORMATION: 'payment-information',
  IDENTITY_VERIFICATION_SETTING: 'identity-verification-setting',
  // Domains
  SETTING_DOMAIN: 'setting-domain',
  CREATE_DOMAIN: 'create-domain',
  SHOW_DOMAIN: 'show-domain',
  UPDATE_DOMAIN: 'update-domain',
  DELETE_DOMAIN: 'delete-domain',
  // Sale report
  VIEW_SALE_REPORT_CHART: 'view_sale_report_chart',
  VIEW_SALE_REPORT_BY_COUNTRY: 'view_sale_report_by_country',
  VIEW_SALE_REPORT_BY_OFFER: 'view_sale_report_by_offer',
  VIEW_SALE_REPORT_BY_PRODUCT: 'view_sale_report_by_product',
  VIEW_SALE_REPORT_BY_WAREHOUSE: 'view_sale_report_by_warehouse',
  VIEW_SALE_REPORT_BY_CALL_AGENT: 'view_sale_report_by_call_agent',
  VIEW_SALE_REPORT_BY_SELLER: 'view_sale_report_by_seller',
  VIEW_SALE_REPORT_BY_REFERRER: 'view_sale_report_by_referrer',
  VIEW_SALE_REPORT_BY_SALE_PAGE: 'view_sale_report_by_sale_page',
  VIEW_SALE_REPORT_BY_MANAGER: 'view_sale_report_by_manager',
  // Accounting
  VIEW_ACCOUNTING_CHART: 'view_accounting_chart',
  VIEW_ACCOUNTING_BY_COUNTRY: 'view_accounting_by_country',
  VIEW_ACCOUNTING_BY_OFFER: 'view_accounting_by_offer',
  VIEW_ACCOUNTING_BY_PRODUCT: 'view_accounting_by_product',
  VIEW_ACCOUNTING_BY_WAREHOUSE: 'view_accounting_by_warehouse',
  VIEW_ACCOUNTING_BY_CALL_AGENT: 'view_accounting_by_call_agent',
  VIEW_ACCOUNTING_BY_SELLER: 'view_accounting_by_seller',
  VIEW_ACCOUNTING_BY_MANAGER: 'view_accounting_by_manager',
  // invoices
  GENERATE_PAYOUT_INVOICES: 'generate-payout-invoices',
  GENERATE_REMITTANCE_INVOICES: 'generate-remittance-invoices',
  GENERATE_EXPENSES_INVOICES: 'generate-expenses-invoices',
  GENERATE_COMMISSION_INVOICES: 'generate-commission-invoices',
  REMOVE_ORDER_FROM_INVOICE: 'remove-order-from-invoice',
  PAY_INVOICE: 'pay-invoice',
  PAY_PAYOUT_INVOICE: 'pay-payout-invoice',
  PAY_REMITTANCE_INVOICE: 'pay-remittance-invoice',
  PAY_EXPENSES_INVOICE: 'pay-expenses-invoice',
  PAY_COMMISSION_INVOICE: 'pay-commission-invoice',
  DELETE_INVOICE: 'delete-invoice'
};
let setValidationMessages = (form, messages) => {
  // this line removes any number at the end of each message key ex: field.0 => field
  messages = Object.assign(...Object.keys(messages).map(k => ({
    [k.replace(/\.\d+$/, '')]: messages[k]
  })));
  Object.keys(form).forEach(f => MOA(form[f], messages, 'messages', 'content', 'fieldName', []));
};
let setSnackErrorMessages = (snack, messages) => {
  snack.open = true;
  snack.type = 'error';
  snack.content = messages;
};
let setSnackSuccessMessages = (snack, messages) => {
  snack.open = true;
  snack.type = 'success';
  snack.content = messages;
};
let setGlobalErrorMessages = (globalError, messages) => {
  globalError.type = 'error';
  globalError.messages = messages;
};
let setGlobalSuccessMessages = (globalError, messages) => {
  globalError.type = 'success';
  globalError.messages = messages;
};
let scrollTo = (vuetify, target, options = null) => {
  var _options$duration, _options, _options$offset, _options2, _options$easing, _options3;
  options = {
    duration: (_options$duration = (_options = options) === null || _options === void 0 ? void 0 : _options.duration) !== null && _options$duration !== void 0 ? _options$duration : 200,
    offset: (_options$offset = (_options2 = options) === null || _options2 === void 0 ? void 0 : _options2.offset) !== null && _options$offset !== void 0 ? _options$offset : 0,
    easing: (_options$easing = (_options3 = options) === null || _options3 === void 0 ? void 0 : _options3.easing) !== null && _options$easing !== void 0 ? _options$easing : 'easeInOutCubic'
  };
  vuetify.goTo(target, options);
};
function getValueByDotNotation(object, dotNotations = 'text', ...rest) {
  var _dotNotations;
  dotNotations = (_dotNotations = dotNotations) !== null && _dotNotations !== void 0 ? _dotNotations : 'text';
  if (!isString(dotNotations) && isNaN(dotNotations) && !Array.isArray(dotNotations) || !isObject(object) && !Array.isArray(object)) return object;
  if (!isNaN(dotNotations)) dotNotations = String(dotNotations);
  if (!Array.isArray(dotNotations)) dotNotations = [dotNotations];
  return dotNotations.reduce((init, dotNotation) => {
    if (init !== undefined) return init;
    return dotNotation === '*' ? object : dotNotation.split('.').reduce((obj, k) => {
      var _obj$k;
      return isFunction(obj === null || obj === void 0 ? void 0 : obj[k]) ? obj === null || obj === void 0 || (_obj$k = obj[k]) === null || _obj$k === void 0 ? void 0 : _obj$k.call(obj, ...rest) : obj === null || obj === void 0 ? void 0 : obj[k];
    }, object);
  }, undefined);
}
function convertToFloat(number, fix_to = null) {
  let float_number = parseFloat(number);
  let nan_test = isNaN(float_number);
  if ((fix_to > 0 || fix_to === 0) && !nan_test) float_number = float_number.toFixed(fix_to);
  return Number(!nan_test ? float_number : 0);
}
function hexToRgb(hex) {
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}
function getTotal(items, header, type = 'sum') {
  var _items$, _items$$toString$repl, _items$$toString, _ref2, _ref2$toFixed;
  let pattern = /[+-]?\d+(\.\d+)*/;
  return (_items$ = items[0]) === null || _items$ === void 0 || (_items$ = _items$[header]) === null || _items$ === void 0 || (_items$$toString$repl = (_items$$toString = _items$.toString()).replace) === null || _items$$toString$repl === void 0 ? void 0 : _items$$toString$repl.call(_items$$toString, pattern, parseFloat((_ref2 = (items === null || items === void 0 ? void 0 : items.reduce((a, b) => {
    var _pattern$exec;
    return a + parseFloat((_pattern$exec = pattern.exec(b[header])) === null || _pattern$exec === void 0 ? void 0 : _pattern$exec[0]);
  }, 0)) / (type === 'avg' ? (items === null || items === void 0 ? void 0 : items.length) > 0 ? items.length : 1 : 1)) === null || _ref2 === void 0 || (_ref2$toFixed = _ref2.toFixed) === null || _ref2$toFixed === void 0 ? void 0 : _ref2$toFixed.call(_ref2, 2)).toString());
}
function getTableTotal(headers, items, header) {
  return header.t === false ? '-' : findIndex(headers, header) > 0 ? getTotal(items, header.value, header.t) : 'sale_reports_page.tables.total';
}
function vuetifyTableHeaderI18nMobileHack(table_header, context) {
  const t = context.$t.bind(context);
  let new_header = [];
  table_header.forEach(h => {
    let n_h = cloneDeep(h);
    n_h.text = t(h.text);
    n_h.value = t(h.value);
    new_header.push(n_h);
  });
  return new_header;
}
function arrayInterlace(array) {
  return array.reduce((init, next) => {
    var _ref3, _ref4;
    let bigger_array = (_ref3 = (init === null || init === void 0 ? void 0 : init.length) > (next === null || next === void 0 ? void 0 : next.length) ? init : next) !== null && _ref3 !== void 0 ? _ref3 : [];
    let smaller_array = (_ref4 = (init === null || init === void 0 ? void 0 : init.length) > (next === null || next === void 0 ? void 0 : next.length) ? next : init) !== null && _ref4 !== void 0 ? _ref4 : [];
    return [bigger_array.map((n, i) => [n, smaller_array[i]].filter(r => r).flat()).filter(r => r)];
  }).flat();
}
function refreshStringifiedModel(classInstance, instance) {
  if (!isObject(instance)) return null;
  Object.keys(instance).forEach(k => {
    var _instance$k;
    if (!classInstance.hasOwnProperty(k)) return;
    let content = (_instance$k = instance[k]) === null || _instance$k === void 0 ? void 0 : _instance$k.content;
    let ClassInstanceModel = classInstance[k].model;
    if (!ClassInstanceModel) return classInstance[k] = instance[k];
    classInstance[k].content = Array.isArray(content) ? instance[k].content.map(instanceItem => refreshStringifiedModel(new ClassInstanceModel(), instanceItem)) : isObject(content) ? refreshStringifiedModel(new ClassInstanceModel(), instance[k].content) : classInstance[k].content;
  });
  return classInstance;
}
function replaceSpecialChars(str) {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
  .replace(/([^\wء-ي]+|\s+)/g, '-') // Replace space and other characters by hyphen
  .replace(/\-\-+/g, '-') // Replaces multiple hyphens by one hyphen
  .replace(/(^-+|-+$)/g, ''); // Remove extra hyphens from beginning or end of the string
}
function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
function removeHtmlTagsFromString(string, tags = []) {
  //let regex = `<\/?(${Array.isArray(tags) && tags.length > 0 ? tags.filter(tag => tag).join('|') : 'p'})[^>]*>`
  let regex = `<\/?[^>]*>`;
  return string.replace(new RegExp(regex, 'g'), ' ').replace(/<[^/>]*><\/[^>]*>/, '');
}
function treeValidationByMessage(object, messageKey, messageContent, type) {
  let messageKeySplit = messageKey.split('.');
  let currentKeySplit = messageKeySplit.shift();
  let keyByFieldName = Object.keys(object).find(ok => {
    var _object$ok;
    return ((_object$ok = object[ok]) === null || _object$ok === void 0 ? void 0 : _object$ok.fieldName) === currentKeySplit;
  });
  let subObjectKey = object.hasOwnProperty(currentKeySplit) ? currentKeySplit : object.hasOwnProperty(keyByFieldName) ? keyByFieldName : object.hasOwnProperty('content') ? 'content' : null;
  if (subObjectKey === 'content' && type === 'blocks' && object.fieldName !== currentKeySplit) messageKeySplit.unshift(currentKeySplit);
  if (!subObjectKey) return;
  let subObject = object.fieldName === currentKeySplit ? object : object[subObjectKey];
  if (!subObject) return;
  messageKeySplit.length < 1 || messageKeySplit.length === 1 && messageKeySplit[0] === 'content' && type === 'blocks' ? isObject(subObject) ? subObject.messages = messageContent : null : treeValidationByMessage(subObject, messageKeySplit.join('.'), messageContent, type);
}
function treeValidation(object, messages, type) {
  Object.keys(messages).forEach(message => treeValidationByMessage(object, message, messages[message], type));
}
function emptyTreeValidation(tree) {
  var _tree$messages;
  Array.isArray(tree) ? tree.forEach(subTree => emptyTreeValidation(subTree)) : (tree === null || tree === void 0 || (_tree$messages = tree.messages) === null || _tree$messages === void 0 ? void 0 : _tree$messages.length) > 0 ? tree.messages = [] : isObject(tree) ? Object.keys(tree).forEach(treeKey => emptyTreeValidation(tree[treeKey])) : null;
}
function generateDiscount({
  discount,
  quantity,
  sale_price,
  normal_price,
  currency
}) {
  var _discount$replace;
  let pattern = /({{dis}})?({{up}})?/g;
  if (!discount) return discount;
  return discount === null || discount === void 0 || (_discount$replace = discount.replace) === null || _discount$replace === void 0 ? void 0 : _discount$replace.call(discount, pattern, function (match) {
    switch (match) {
      case '{{dis}}':
        return parseInt((100 - sale_price / normal_price * 100).toString()) + '%';
      case '{{up}}':
        return parseInt((sale_price / quantity).toString()) + currency;
    }
    return '';
  });
}
function convertFileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    let fr = new FileReader();
    fr.onload = e => resolve(e.target.result);
    fr.onerror = e => reject(e);
    if (!(file instanceof File)) reject('file not found.');
    fr.readAsDataURL(file);
  });
}
let date_time_format = 'YYYY-MM-DD HH:mm';
let date_format = 'YYYY-MM-DD';
let time_format = 'HH:mm:ss';
function fieldContent(field) {
  if (!isObject(field)) return field;
  if (!isFunction(field.customContent) && !field.hasOwnProperty('content')) return field;
  let content = isFunction(field.customContent) ? field.customContent() : field.content;
  if (field.type === 'json') return content;
  if (Array.isArray(content)) return content.map(subField => fieldContent(subField));
  return content;
}
function classInstanceStringifier(classInstance) {
  return Object.keys(classInstance).reduce((init, key) => {
    let field = classInstance[key];
    if (isObject(field) && field.hasOwnProperty('fieldName')) {
      init[field['fieldName']] = fieldContent(field);
    }
    return init;
  }, {});
}
function requestObjectStringifier() {
  return Object.assign({}, ...Object.keys(this).map(f => this[f]['fieldName'] && this[f]['toForm'] !== false ? {
    [this[f]['fieldName']]: requestObjectStringifierCc(this[f].type, isFunction(this[f].getTranslatedContent) ? this[f].getTranslatedContent() : isFunction(this[f].customContent) ? this[f].customContent() : this[f].content, this[f])
  } : null).filter(e => e));
}

// convert content to primitive values if the type is not json
function requestObjectStringifierCc(ty, c, field) {
  var _c$Id, _ref5, _c$field$optionValueK;
  return ty === 'date' ? c : ty !== 'json' ? isObject(c) ? (c === null || c === void 0 ? void 0 : c.Id) !== undefined ? c === null || c === void 0 || (_c$Id = c.Id) === null || _c$Id === void 0 ? void 0 : _c$Id.content : (_ref5 = (_c$field$optionValueK = c === null || c === void 0 ? void 0 : c[field === null || field === void 0 ? void 0 : field.optionValueKey]) !== null && _c$field$optionValueK !== void 0 ? _c$field$optionValueK : c === null || c === void 0 ? void 0 : c.value) !== null && _ref5 !== void 0 ? _ref5 : c : Array.isArray(c) ? c.map(sf => requestObjectStringifierCc(null, sf, field)) : c : c;
}
function apiRequestStringifier(key, object) {
  return objectStringifier(key, object, field => {
    var _field$content;
    return isFunction(field.customContent) ? field.customContent() : isFunction(field.apiCustomContent) ? field.apiCustomContent() : Array.isArray(field.content) ? field.content.map(item => item instanceof Model || item instanceof JsonMappedModel ? item.getId() : item) : field.content instanceof Model || field.content instanceof JsonMappedModel ? field.content.getId() : (_field$content = field.content) !== null && _field$content !== void 0 ? _field$content : null;
  });
}
function browserStorageStringifier(key, object) {
  return objectStringifier(key, object, field => {
    var _field$content2;
    return isFunction(field.customContent) ? field.customContent() : isFunction(field.browserCustomContent) ? field.browserCustomContent() : isFunction(field.apiCustomContent) ? field.apiCustomContent() : (_field$content2 = field.content) !== null && _field$content2 !== void 0 ? _field$content2 : null;
  });
}
function browserDraftsStorageStringifier(key, object) {
  if (object instanceof Model || object instanceof JsonMappedModel) return object;
  return objectStringifier(key, object, field => {
    var _field$content3;
    return isFunction(field.customContent) ? field.customContent() : isFunction(field.browserCustomContent) ? field.browserCustomContent() : (_field$content3 = field.content) !== null && _field$content3 !== void 0 ? _field$content3 : null;
  });
}
function objectStringifier(key, object, fieldContentResolver) {
  if (isObject(object)) {
    if (object.hasOwnProperty('fieldName')) {
      return {
        [object.fieldName]: fieldContentResolver(object)
      };
    }
    return Object.keys(object).filter(subKey => isObject(object[subKey]) && object[subKey].hasOwnProperty('fieldName')).reduce((init, nextKey) => {
      init[object[nextKey].fieldName] = fieldContentResolver(object[nextKey]);
      return init;
    }, {});
  }
  return object;
}

/*function objectStringifier(key) {
    let context = this[key]
    if (!isObject(context)) return context

    return classInstanceStringifier(context)
}*/

function getAuthTypeInstance(authType, classType = 'model') {
  var _auths$authType;
  let auths = {
    [BasicAuth.NAME]: {
      model: BasicAuth,
      form: BasicAuthForm
    },
    [BearerTokenAuth.NAME]: {
      model: BearerTokenAuth,
      form: BearerTokenAuthForm
    }
  };
  let Auth = (_auths$authType = auths[authType]) === null || _auths$authType === void 0 ? void 0 : _auths$authType[classType];
  if (!Auth) return null;
  return new Auth();
}
function getBlockInstance(blockType, type = 'model', instance = true, blockArgs = {}) {
  var _blocks$blockType;
  let blocks = {
    [BulletBlock.NAME]: {
      model: BulletBlock,
      form: BulletBlockForm
    },
    [ButtonBlock.NAME]: {
      model: ButtonBlock,
      form: ButtonBlockForm
    },
    [FaqBlock.NAME]: {
      model: FaqBlock,
      form: FaqBlockForm
    },
    [FaqsBlock.NAME]: {
      model: FaqsBlock,
      form: FaqsBlockForm
    },
    [FigureBlock.NAME]: {
      model: FigureBlock,
      form: FigureBlockForm
    },
    [FiguresBlock.NAME]: {
      model: FiguresBlock,
      form: FiguresBlockForm
    },
    [GalleryBlock.NAME]: {
      model: GalleryBlock,
      form: GalleryBlockForm
    },
    [HeaderBlock.NAME]: {
      model: HeaderBlock,
      form: HeaderBlockForm
    },
    [JournalBlock.NAME]: {
      model: JournalBlock,
      form: JournalBlockForm
    },
    [ReviewBlock.NAME]: {
      model: ReviewBlock,
      form: ReviewBlockForm
    },
    [ReviewsBlock.NAME]: {
      model: ReviewsBlock,
      form: ReviewsBlockForm
    },
    [SimpleGalleryBlock.NAME]: {
      model: SimpleGalleryBlock,
      form: SimpleGalleryBlockForm
    },
    [SingleImageBlock.NAME]: {
      model: SingleImageBlock,
      form: SingleImageBlockForm
    },
    [VideoBlock.NAME]: {
      model: VideoBlock,
      form: VideoBlockForm
    },
    [TrustBlock.NAME]: {
      model: TrustBlock,
      form: TrustBlockForm
    },
    [TrustBadgeBlock.NAME]: {
      model: TrustBadgeBlock,
      form: TrustBadgeBlockForm
    },
    [HeroBlock.NAME]: {
      model: HeroBlock,
      form: HeroBlockForm
    },
    [ProductListBlock.NAME]: {
      model: ProductListBlock,
      form: ProductListBlockForm
    },
    [BrandDomainBlock.NAME]: {
      model: BrandDomainBlock,
      form: BrandDomainBlockForm
    },
    [ArticleBlock.NAME]: {
      model: ArticleBlock,
      form: ArticleBlockForm
    },
    [ContactBlock.NAME]: {
      model: ContactBlock,
      form: ContactBlockForm
    },
    [PageHeaderBlock.NAME]: {
      model: PageHeaderBlock,
      form: PageHeaderBlockForm
    },
    [LinkBlock.NAME]: {
      model: LinkBlock,
      form: LinkBlockForm
    },
    [PageFooterBlock.NAME]: {
      model: PageFooterBlock,
      form: PageFooterBlockForm
    },
    [FooterInfoBlock.NAME]: {
      model: FooterInfoBlock,
      form: FooterInfoBlockForm
    },
    [FooterLinksBlockForm.NAME]: {
      model: FooterLinksBlock,
      form: FooterLinksBlockForm
    },
    [FooterBenefitsBlockForm.NAME]: {
      model: FooterBenefitsBlock,
      form: FooterBenefitsBlockForm
    },
    [ContentPlaceholderBlock.NAME]: {
      model: ContentPlaceholderBlock,
      form: ContentPlaceholderBlockForm
    },
    [ComplianceBarBlock.NAME]: {
      model: ComplianceBarBlock,
      form: ComplianceBarBlockForm
    },
    [AnnouncementBarBlock.NAME]: {
      model: AnnouncementBarBlock,
      form: AnnouncementBarBlockForm
    },
    [SocialMediaLinkBlockForm.NAME]: {
      model: SocialMediaLinkBlock,
      form: SocialMediaLinkBlockForm
    }
  };
  let Block = (_blocks$blockType = blocks[blockType]) === null || _blocks$blockType === void 0 ? void 0 : _blocks$blockType[type];
  if (!Block) return null;
  if (!instance) {
    return Block;
  }
  return new Block(blockArgs);
}
function hexToHSL(hex) {
  var _result$;
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i.exec(hex);
  if (!result) return null;
  let r = parseInt(result[1], 16);
  let g = parseInt(result[2], 16);
  let b = parseInt(result[3], 16);
  let o = parseInt((_result$ = result[4]) !== null && _result$ !== void 0 ? _result$ : 'FF', 16) / 255;
  r /= 255, g /= 255, b /= 255;
  let max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  let h,
    s,
    l = (max + min) / 2;
  if (max == min) {
    h = s = 0; // achromatic
  } else {
    let d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h,
    s,
    l,
    o
  };
}
function convertHslaObjectToString(hsla) {
  return `hsla(${hsla.h * 360}, ${hsla.s * 100}%, ${hsla.l * 100}%, ${hsla.o})`;
}
function secondaryLighter(color, times = 1) {
  let hsla = hexToHSL(color);
  if (!isObject(hsla)) return null;
  hsla.l += times * (1 - hsla.l) / 6;
  return convertHslaObjectToString(hsla);
}
function convertLastHalfToAsterisks(str) {
  let length = str === null || str === void 0 ? void 0 : str.length;
  if (length < 1 || !length) return str;
  let midpoint = Math.floor(length / 2);
  let firstHalf = str.substring(0, midpoint);
  let asterisks = '*'.repeat(length - midpoint);
  return firstHalf + asterisks;
}
function preservativeMerge(firstObject, secondObject) {
  return mergeWith({}, firstObject, secondObject, (objValue, srcValue) => {
    if (isObject(objValue)) {
      return mergeWith(cloneDeep(objValue), srcValue);
    }
  });
}
function arrayMax(array, attributeDotNotation) {
  return array.reduce((prev, current) => {
    let value = getValueByDotNotation(current, attributeDotNotation);
    return value > prev ? value : prev;
  }, -Infinity);
}
function getMessagesKeyFirstPartRemoved(messages, stringToRemove) {
  if (!isObject(messages) || Object.keys(messages).filter(message => !!message).length < 1) return;
  return Object.fromEntries(Object.entries(messages).map(item => [item[0].replace(new RegExp(`^${stringToRemove}\.?`), ''), item[1]]));
}
function toBase64(string) {
  return window.btoa(string).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function mergeRequestQueries(queries) {
  if (!Array.isArray(queries)) return '';
  return queries.reduce((init, query) => [init, query.replace('?', '')].join('&'), '?');
}
function getDynamicallyColoredSvg(name) {
  var _svgImages$name;
  let svgImages = {
    'e-commerce': MainSectionSVG,
    'great-service': PurchaseGiftSVG,
    'great-client-service': CallAgentSVG,
    'about-us': AboutUsSVG,
    'free-delivery': TruckIcon,
    'trusted-site': TrustedSiteIcon,
    'secured-payment': SecureCheckoutIcon,
    'fast-support': CallAgentIcon,
    'return-guarantee': ReturnGuarantee
  };
  return (_svgImages$name = svgImages[name]) !== null && _svgImages$name !== void 0 ? _svgImages$name : null;
}
export { getDynamicallyColoredSvg, mergeRequestQueries, toBase64, getMessagesKeyFirstPartRemoved, arrayMax, preservativeMerge, convertLastHalfToAsterisks, levels, date_format, date_time_format, time_format, isJSON, hexToHSL, secondaryLighter, objectStringifier, browserDraftsStorageStringifier, apiRequestStringifier, browserStorageStringifier, getBlockInstance, getAuthTypeInstance, convertFileToDataUrl, generateDiscount, treeValidation, emptyTreeValidation, removeHtmlTagsFromString, formatBytes, replaceSpecialChars, refreshStringifiedModel, arrayInterlace, vuetifyTableHeaderI18nMobileHack, getTotal, getTableTotal, hexToRgb, convertToFloat, getValueByDotNotation, setGlobalSuccessMessages, scrollTo, setGlobalErrorMessages, MOA, setSnackErrorMessages, setSnackSuccessMessages, setValidationMessages, EmptyFormValidations, EmptyFormFields, PopulateFormFields, getFieldName, FormatDate, serializeObject, getFormData, permitted, getYoutubeVideoImage, getYoutubeVideoEmbed, convertDateToChunks, getNumberFromString, permittedRole, permissions, PERMISSIONS, sendGoogleTagEvent, getType, getTranslation, isObject, isArray, isFunction, isString, emptyDeepMessages, isBoolean, requestObjectStringifier };